import React, {FunctionComponent} from "react"
import {IconContext} from "react-icons/lib"
import {TbBuildingBank, TbUrgent, TbActivityHeartbeat, TbAntennaBars1, TbWorldUpload} from "react-icons/tb"
import {IoBookOutline} from "react-icons/io5"
import {FaStairs} from "react-icons/fa6"

interface CheckboxInputProps {
	name: string
	disabled?: boolean
	register: any
	value: string
	title: string
}

const CheckboxInput: FunctionComponent<CheckboxInputProps> = ({name, disabled = false, register, value, title}) => {
	const icon = (id: number) => {
		switch (id) {
			case 1:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbUrgent />
					</IconContext.Provider>
				)
			case 2:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbActivityHeartbeat />
					</IconContext.Provider>
				)
			case 3:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<IoBookOutline />
					</IconContext.Provider>
				)
			case 4:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<IoBookOutline />
					</IconContext.Provider>
				)
			case 5:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbBuildingBank />
					</IconContext.Provider>
				)
			case 6:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbBuildingBank />
					</IconContext.Provider>
				)
			case 7:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<FaStairs />
					</IconContext.Provider>
				)
			case 8:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbWorldUpload />
					</IconContext.Provider>
				)
			case 9:
				return (
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<TbWorldUpload />
					</IconContext.Provider>
				)
			default:
				return null
		}
	}
	return (
		<div className='field-checkbox-wrapper'>
			<label htmlFor={value}>
				<span className='field-checkbox-icon'>
					{icon(parseInt(value))}
					{title}
				</span>
			</label>
			<input type='checkbox' id={value} name='modules' value={value} disabled={disabled} {...register(name)} />
		</div>
	)
}

export default CheckboxInput
